module.exports = __webpack_public_path__ + "static/img/keshihua1.9b5f065a.png";